'use client'
import { useState, useEffect, useRef } from 'react'
import { useRouter } from 'next/navigation'
import Image from 'next/image'
import Typed from 'typed.js'

const SearchBar = ({ filters = '', autoFocus = true }: { filters?: string, autoFocus?: boolean }) => {
  const [query, setQuery] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)
  const { push } = useRouter()
  const [searchHover, setSearchHover] = useState(false)

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter') return
    handleSubmit(e)
  }

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    push(`/advancedSearch?query=${query}${filters}`)
  }

  useEffect(() => {
    if (inputRef.current) {
      const typed = new Typed(inputRef.current, {
        strings: [
          'Search for a Student',
          'Search for a Professor',
          'Search for a Professional',
          'Search for a Medical Professional',
        ],
        typeSpeed: 50,
        backSpeed: 25,
        backDelay: 1500,
        startDelay: 500,
        loop: true,
        showCursor: false,
        attr: 'placeholder',
        contentType: 'html',
        smartBackspace: false,
      })
      return () => {
        if (typed) {
          typed.destroy()
        }
      }
    }
  }, [])

  return (
    <div className="w-full max-w-[452px]">
      <form
        action=""
        role="search"
        noValidate
        onSubmit={handleSubmit}
        className="flex justify-center w-full max-[768px]:justify-center gap-[8px]"
      >
        <input
          id="search"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          value={query}
          ref={inputRef}
          type="search"
          className="bg-white w-full max-w-[393px] md:w-[393px] cursor-text placeholder:text-black placeholder:italic placeholder:font-normal placeholder:text-[15px] placeholder:w-full h-[32px] !rounded-[10px] shadow-[0_1px_2px_rgba(0,0,0,0.25)] lg/6 focus:border-none focus:outline-none max-[768px]:h-[41px] border-none"
          onKeyDown={(e) => handleKeyDown(e)}
          onChange={(event) => {
            setQuery(event.currentTarget.value)
          }}
          autoFocus={autoFocus}
        />
        <button
          onMouseOver={() => setSearchHover(true)}
          onMouseLeave={() => setSearchHover(false)}
          className="leading-[20.8571px] py-[1px] px-1.5 bg-black w-[40px] inline-flex items-center justify-center hover:bg-feYellow max-[768px]:w-[51px] max-[768px]:min-w-[51px] h-[32px] !rounded-[10px] shadow-[0_1px_2px_rgba(0,0,0,0.25)] focus:border-none focus:outline-none max-[768px]:h-[41px]"
          type="submit"
        >
          <Image
            loading="eager"
            alt={'search_icon'}
            width={19}
            height={19}
            className="w-[14px] h-[17px]"
            src={`/images/favicons/search1${searchHover ? '_black' : ''}.svg`}
          />
        </button>
      </form>
    </div>
  )
}
export default SearchBar
